<!-- Breadcrumbs -->
<div class="mt-1">
    <p-breadcrumb class="max-w-full" [model]="items" [home]="home"></p-breadcrumb>
</div>

<div *ngIf="patient && patient.id" class="rounded-card py-2 px-5">
    <div class="grid mt-1 align-items-stretch">
        <!-- Left Main Column (Profile data + Submission Status) -->
        <div class="col-6 d-flex flex-column gap-2">
            <!-- PROFILE CARD (Merged Profile + Contact) -->
            <div class="bg-white p-3 rounded-card card-shadow">
                <div class="grid">
                    <!-- Left Section: Avatar, Name & Metrics -->
                    <div class="col-5 border-end">
                        <div class="d-flex flex-column align-items-center h-100 text-center">
                            <!-- Row 1: Avatar -->
                            <div class="mb-2">
                                <p-avatar icon="pi pi-user" styleClass="bg-gray-200 text-gray-600" size="xlarge"
                                    shape="circle"></p-avatar>
                            </div>

                            <!-- Row 2: Name & Details -->
                            <div class="mb-3 w-100">
                                <h5 class="fw-bold mb-1 patient-name">{{ patient.fullName }}</h5>
                                <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap">
                                    <span class="text-secondary small">MRN: {{ patient.mrn || 'N/A' }}</span>
                                    <div class="d-flex align-items-center">
                                        <span class="status-dot"
                                            [style.background-color]="(patient.patientInrStatus === 'MONITORED' || patient.patientInrStatus === 'ACTIVE') ? '#28a745' : '#6c757d'"></span>
                                        <span class="small text-muted status-text">{{
                                            patient.patientInrStatus || 'N/A' }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Row 3: Metrics (Styled as User Info) -->
                            <div class="d-flex justify-content-between w-100 mt-auto px-2">
                                <div>
                                    <span class="data-label">Blood</span>
                                    <span class="data-value">{{ patient.bloodType || 'N/A' }}</span>
                                </div>
                                <div>
                                    <span class="data-label">Target INR</span>
                                    <span class="data-value">{{ (patient.targetInrFrom && patient.targetInrTo) ?
                                        (patient.targetInrFrom + ' - ' + patient.targetInrTo) : 'N/A' }}</span>
                                </div>
                                <div>
                                    <span class="data-label">Target Dose</span>
                                    <span class="data-value">{{ patient.targetMarivanDose ? patient.targetMarivanDose +
                                        ' mg' : 'N/A' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Right Section: Info Columns -->
                    <div class="col-7 pl-4">
                        <div class="grid h-100">
                            <div class="col-6">
                                <h6 class="info-title mb-2">Basic Info</h6>

                                <div class="mb-1">
                                    <span class="data-label">Gender</span>
                                    <span class="data-value">{{ patient.gender || 'N/A' }}</span>
                                </div>
                                <div class="mb-1">
                                    <span class="data-label">Date of Birth</span>
                                    <span class="data-value">{{ patient.birthDate | date : 'dd MMMM yyyy' }}</span>
                                </div>
                                <div class="mb-1">
                                    <span class="data-label">National ID</span>
                                    <span class="data-value">{{ patient.nationalId || 'N/A' }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <h6 class="info-title mb-2">Contact Info</h6>

                                <div class="mb-1">
                                    <span class="data-label">Home Address</span>
                                    <span class="data-value text-wrap" pTooltip="{{ patient.address }}"
                                        tooltipPosition="top">
                                        {{ patient.address || 'N/A' }}
                                    </span>
                                </div>
                                <div class="mb-1">
                                    <span class="data-label">Patient phone</span>
                                    <span class="data-value">{{ patient.phoneNumber || 'N/A' }}</span>
                                </div>
                                <div class="mb-1">
                                    <span class="data-label">Email Address</span>
                                    <span class="data-value text-truncate d-block" pTooltip="{{ patient.email }}"
                                        tooltipPosition="top">
                                        {{ patient.email || 'N/A' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SUBMISSION STATUS CARD -->
            <div class="bg-white rounded-card overflow-hidden card-shadow">
                <!-- Header -->
                <div class="status-header" [ngClass]="patient.submissionStatus || 'status-header-default'">
                    <span class="fw-bold fs-5">Submission Status</span>
                    <span class="fw-bold small px-2 py-1">
                        {{ (patient.submissionStatus === 'WAITING_FOR_RESPONSE' ? 'PENDING' : patient.submissionStatus)
                        || 'N/A' }}
                    </span>
                </div>

                <div class="p-3 d-flex flex-column reports-container">
                    <!-- INR Reports Table -->
                    <app-inr-patient-reports class="flex-grow-1" [inrSet]="patient.inrRequest"
                        [selectedRequest]="selectedInrRequest" [nationalId]="patient.nationalId"
                        (onSelectionChange)="onRequestSelected($event)">
                    </app-inr-patient-reports>
                </div>
            </div>
        </div>

        <!-- Right Main Column (Details) -->
        <div class="col-6">
            <div class="bg-white p-3 h-100 d-flex flex-column gap-2 rounded-card card-shadow">


                <!-- Patient Note -->
                <div>
                    <div class="d-flex justify-content-between mb-2">
                        <span class="fw-bold fs-6">Patient Note</span>
                    </div>
                    <div class="note-box" dir="auto">
                        {{ selectedInrRequest?.notes || 'No notes available' }}
                    </div>
                </div>

                <hr class="text-muted my-2">

                <!-- Response Details -->
                <div>
                    <div class="d-flex justify-content-between mb-2">
                        <span class="fw-bold fs-6">Response details</span>
                    </div>

                    <div class="border rounded px-3 py-2 d-flex text-center bg-white response-details-box">
                        <div class="flex-grow-1 px-2">
                            <div class="small text-muted mb-1">Next Dose</div>
                            <div class="fw-bold">
                                {{ selectedInrRequest?.inrResponse?.nextMarivanDose ?
                                selectedInrRequest?.inrResponse?.nextMarivanDose + ' Mg' : '-' }}
                            </div>
                        </div>
                        <div class="flex-grow-1 border-start border-end px-2">
                            <div class="small text-muted mb-1">Responded</div>
                            <div class="fw-bold small">
                                {{ (selectedInrRequest?.inrResponse?.respondedAt | date:'dd/MM/yyyy') || '-' }}
                            </div>
                        </div>
                        <div class="flex-grow-1 px-2">
                            <div class="small text-muted mb-1">Next Test</div>
                            <div class="fw-bold small">
                                {{ (formatNextTestDate(selectedInrRequest?.inrResponse?.nextTestDate) |
                                date:'dd/MM/yyyy') || '-' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Doctor Note -->
                <div class="flex-grow-1 d-flex flex-column">
                    <div class="d-flex justify-content-between mb-2 mt-3">
                        <span class="fw-bold fs-6">Doctor Note</span>
                    </div>
                    <div class="note-box flex-grow-1" dir="auto">
                        {{ selectedInrRequest?.inrResponse?.responseNote || 'No response note available' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SUBMIT RESPONSE CARD (Bottom) - Only show for PENDING requests (no response yet) -->
    <div class="grid"
        *ngIf="selectedInrRequest && patient.patientInrStatus !== 'INACTIVE' && !selectedInrRequest.inrResponse">
        <div class="col-12">
            <div class="p-3 mt-2 mb-1 rounded-card submit-response-card card-shadow">
                <h6 class="fw-bold mb-2">Submit Response</h6>
                <form [formGroup]="responseForm" (ngSubmit)="submitResponse()">
                    <div class="grid">
                        <!-- Left Column: Inputs Stacked -->
                        <div class="col-6 d-flex flex-column gap-1">
                            <div class="d-flex gap-2">
                                <div class="flex-grow-1">
                                    <label class="d-block mb-1">Next Marivan Dose (mg)</label>
                                    <input pInputText type="number" step="any" formControlName="nextMarivanDose"
                                        class="w-100 p-inputtext-sm" placeholder="Enter dose amount"
                                        [ngClass]="{'ng-invalid ng-dirty': responseForm.get('nextMarivanDose')?.invalid && responseForm.get('nextMarivanDose')?.touched}" />
                                    <small class="p-error d-block"
                                        *ngIf="responseForm.get('nextMarivanDose')?.invalid && responseForm.get('nextMarivanDose')?.touched">
                                        <span *ngIf="responseForm.get('nextMarivanDose')?.errors?.['required']">Dose is
                                            required</span>
                                        <span *ngIf="responseForm.get('nextMarivanDose')?.errors?.['min']">Dose must be
                                            at least 0</span>
                                        <span *ngIf="responseForm.get('nextMarivanDose')?.errors?.['max']">Dose cannot
                                            exceed 20</span>
                                    </small>
                                </div>
                            </div>
                            <div>
                                <label class="d-block mb-1">Next Test Date</label>
                                <p-calendar formControlName="nextTestDate" [showIcon]="true" dateFormat="mm/dd/yy"
                                    placeholder="mm/dd/yyyy" styleClass="w-100 calendar-icon"
                                    inputStyleClass="p-inputtext-sm" [style]="{'width':'100%'}" [minDate]="minDate"
                                    [ngClass]="{'ng-invalid ng-dirty': responseForm.get('nextTestDate')?.invalid && responseForm.get('nextTestDate')?.touched}"></p-calendar>
                                <small class="p-error d-block"
                                    *ngIf="responseForm.get('nextTestDate')?.invalid && responseForm.get('nextTestDate')?.touched">
                                    Next Test Date is required and must be today or in the future
                                </small>
                            </div>
                        </div>

                        <!-- Right Column: Note -->
                        <div class="col-6">
                            <div class="h-100 d-flex flex-column">
                                <div class="d-flex justify-content-between mb-1">
                                    <label class="d-block">Response Note (Optional)</label>
                                    <small class="text-muted">{{ responseForm.get('responseNote')?.value?.length || 0
                                        }}/1000</small>
                                </div>
                                <textarea pInputTextarea formControlName="responseNote" class="w-100 response-note"
                                    placeholder="Write your note here..." dir="auto" maxlength="1000"
                                    [ngClass]="{'ng-invalid ng-dirty': responseForm.get('responseNote')?.invalid && responseForm.get('responseNote')?.touched}"></textarea>
                                <small class="p-error"
                                    *ngIf="responseForm.get('responseNote')?.invalid && responseForm.get('responseNote')?.touched">
                                    <span *ngIf="responseForm.get('responseNote')?.errors?.['maxlength']">Note cannot
                                        exceed 1000 characters</span>
                                    <span *ngIf="responseForm.get('responseNote')?.errors?.['invalidCharacters']">Only
                                        letters, numbers, spaces, and basic punctuation allowed</span>
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-end mt-2">
                        <button pButton label="Submit" class="p-button-primary submit-btn" type="submit"
                            [disabled]="responseForm.invalid"></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>